module.exports = __webpack_public_path__ + "static/img/device_mini_2.95b94da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/device_mini_2.png
// module id = 7CJK
// module chunks = 16